/*global require: false */
require(['jquery'],
    function ($) {
        'use strict';

        $(document).ready(function () {

            var pageSize = 10;
            var maxVisiblePages = 5;
            var maxPagesAllowed = 10;

            var items = document.querySelectorAll('.result-item');
            var totalItems = items.length;

            var totalPages = Math.ceil(totalItems / pageSize);
            if (totalPages > maxPagesAllowed) {
                totalPages = maxPagesAllowed;
            }

            // ✅ Helper: Get query param (IE safe)
            function getQueryParam(name) {
                name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
                var results = regex.exec(window.location.search);
                return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
            }

            // ✅ Helper: Update URL (IE safe)
            var isFirstLoad = true;
            function updateUrl(page) {
                var baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
                var query = window.location.search;
                var newQuery;

                if (query.indexOf('page=') !== -1) {
                    newQuery = query.replace(/([?&])page=\d+/, '$1page=' + page);
                } else {
                    newQuery = query + (query ? '&' : '?') + 'page=' + page;
                }

                var newUrl = baseUrl + newQuery;

                if (isFirstLoad) {
                    window.history.replaceState({}, '', newUrl);
                    isFirstLoad = false;
                } else {
                    window.history.pushState({}, '', newUrl);
                }
            }

            // ✅ Get initial page from URL
            var currentPage = parseInt(getQueryParam('page'), 10) || 1;

            function showPage(page) {
                if (page < 1 || page > totalPages) {
                    return;
                }

                currentPage = page;

                // ✅ Update URL
                updateUrl(page);

                for (var i = 0; i < items.length; i++) {
                    items[i].style.display = 'none';
                }

                var start = (page - 1) * pageSize;
                var end = start + pageSize;

                for (var j = start; j < end && j < totalItems; j++) {
                    items[j].style.display = 'block';
                }

                renderPagination();
                window.scrollTo(0, 0);
            }

            function renderPagination() {
                $('#pagination').empty();
                var prev = $('<li></li>');

                if (currentPage > 1) {
                    $('<a href="#">Prev</a>')
                        .on('click', function (e) {
                            e.preventDefault();
                            showPage(currentPage - 1);
                        })
                        .appendTo(prev);
                } else {
                    $('<span>Prev</span>').appendTo(prev);
                }

                $('#pagination').append(prev);

                var startPage, endPage;

                if (totalPages <= maxVisiblePages) {
                    startPage = 1;
                    endPage = totalPages;
                } else {
                    startPage = currentPage - Math.floor(maxVisiblePages / 2);
                    endPage = currentPage + Math.floor(maxVisiblePages / 2);

                    if (startPage < 1) {
                        startPage = 1;
                        endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
                    }

                    if (endPage > totalPages) {
                        endPage = totalPages;
                    }

                    if (endPage - startPage + 1 < maxVisiblePages) {
                        startPage = Math.max(1, endPage - maxVisiblePages + 1);
                    }
                }

                for (var k = startPage; k <= endPage; k++) {
                    var li = $('<li></li>');

                    if (k === currentPage) {
                        $('<a></a>')
                            .addClass('active')
                            .text(k)
                            .appendTo(li);
                    } else {
                        $('<a href="#"></a>')
                            .text(k)
                            .on('click', (function (page) {
                                return function (e) {
                                    e.preventDefault();
                                    showPage(page);
                                };
                            })(k))
                            .appendTo(li);
                    }

                    $('#pagination').append(li);
                }

                var next = $('<li></li>');

                if (currentPage < totalPages) {
                    $('<a href="#">Next</a>')
                        .on('click', function (e) {
                            e.preventDefault();
                            showPage(currentPage + 1);
                        })
                        .appendTo(next);
                } else {
                    $('<span class="disabled">Next</span>').appendTo(next);
                }

                $('#pagination').append(next);
            }

            // ✅ Handle browser back/forward
            window.addEventListener('popstate', function () {
                var page = parseInt(getQueryParam('page'), 10) || 1;
                showPage(page);
            });

            // ✅ Initial load
            showPage(currentPage);
        });
    });
define("elastic-search", function(){});

